// extracted by mini-css-extract-plugin
export default {"app__nopage":"NotFound_app__nopage__kNYzq","nopage__center":"NotFound_nopage__center__+5t0B","nopage__redirect":"NotFound_nopage__redirect__JDUIu"};